<template>
  <div>
    <v-row id="idClienteSemFaturamento">
      <v-col
        id="componenteSemFaturamento"
        cols="12"
        sm="12"
        md="12"
        lg="6"
      >
        <v-card
          id="cardDashbord"
          class="mx-auto"
          outlined
          :max-width="width"
        >
          <div class="card-header-dashbord">
            <v-row>
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
                class="d-flex flex-wrap"
              >
                Quais meus clientes que não compraram no mês?
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                lg="2"
                class="d-flex justify-end"
              >
                <v-tooltip
                  top
                  max-width="400"
                  width="400"
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-icon
                      id="iconInformationFatxMetaComercial4"
                      class="text-left"
                      v-bind="attrs"
                      v-on="on"
                      @mouseover="enableTexto('175')"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <div
                    v-if="!carregandoTooltip"
                    v-html="textoOrientacao"
                  />
                </v-tooltip>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div
                  v-if="loading"
                  :style="styleObject"
                  class="text-center"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <div
                  v-else
                >
                  <v-card>
                    <v-card-title>
                      <span>Quantidade Clientes: {{ clientesSemFaturamento.length }}</span>
                    </v-card-title>
                    <div
                      id="idTable"
                      style="overflow-x: auto; max-width: 100%;"
                    >
                      <table
                        style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                        class="elevation-1"
                      >
                        <thead>
                          <tr>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Rede Comercial
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Vendedor
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Cliente
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Dias sem faturamento
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in clientesSemFaturamento"
                            :key="item.id"
                          >
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.rede }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.vendedor }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.nome_cliente }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: right;"
                            >
                              {{ item.dias }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-card>
                  <router-link
                    to="/cliente/base-atendimento"
                    :style="styleObject"
                    class="text-center"
                  >
                    <div
                      id="linkDetalheClienteSemFaturamento"
                      class="text-center"
                    >
                      <v-icon
                        id="iconLinkClientesSemFaturamento"
                        class="text-center"
                      >
                        mdi-chevron-double-down
                      </v-icon><br>
                    </div>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card><br>
      </v-col>
      <v-col
        id="componenteSemFaturamento"
        cols="12"
        sm="12"
        md="12"
        lg="6"
      >
        <v-card
          id="cardDashbord"
          class="mx-auto"
          outlined
          :max-width="width"
        >
          <div class="card-header-dashbord">
            <v-row>
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
                class="d-flex flex-wrap"
              >
                Quais clientes estão prestes a inativar?
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                lg="2"
                class="d-flex justify-end"
              >
                <v-tooltip
                  top
                  max-width="400"
                  width="400"
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-icon
                      id="iconInformationFatxMetaComercial4"
                      class="text-left"
                      v-bind="attrs"
                      v-on="on"
                      @mouseover="enableTexto('176')"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <div
                    v-if="!carregandoTooltip"
                    v-html="textoOrientacao"
                  />
                </v-tooltip>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div
                  v-if="loading"
                  :style="styleObject"
                  class="text-center"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <div
                  v-else
                >
                  <v-card>
                    <v-card-title>
                      <span>Quantidade Clientes: {{ clientesInativo.length }}</span>
                    </v-card-title>
                    <div
                      id="idTable"
                      style="overflow-x: auto; max-width: 100%;"
                    >
                      <table
                        style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                        class="elevation-1"
                      >
                        <thead>
                          <tr>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Rede Comercial
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Vendedor
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Cliente
                            </th>
                            <th
                              id="dadoMovimentacaoHeader"
                              style="text-align: center;"
                              class="black--text title"
                            >
                              Dias sem faturamento
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in clientesInativo"
                            :key="item.id"
                          >
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.rede }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.vendedor }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: left;"
                            >
                              {{ item.nome_cliente }}
                            </td>
                            <td
                              id="dadoMovimentacao"
                              style="text-align: right;"
                            >
                              {{ item.dias }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-card>
                  <router-link
                    to="/somenteclientes/detalhe-cliente-proximo-inativar"
                    :style="styleObject"
                    class="text-center"
                  >
                    <div
                      id="linkDetalheClienteSemFaturamento"
                      class="text-center"
                    >
                      <v-icon
                        id="iconLinkClientesInativos"
                        class="text-center"
                      >
                        mdi-chevron-double-down
                      </v-icon><br>
                    </div>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Clientes from '../../../../../services/somentecliente'
  import Permissao from '../../../../../services/menu'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowClientesSemFaturamento',
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      textoPartipantesSemFat: '',
      textoPartipantesInativos: '',
      codigo: 0,
      orientacao: JSON.parse(localStorage.getItem('orientacaoCliente')),
      headersClientes: [
        { text: 'Rede Comercial', value: 'rede', width: '20%', class: 'dias-column black--text title' },
        { text: 'Vendedor', value: 'vendedor', width: '35%', class: 'vendedor-column black--text title' },
        { text: 'Cliente', value: 'nome_cliente', width: '35%', class: 'cliente-column black--text title' },
        { text: 'Dias sem faturamento', value: 'dias', width: '10%', align: 'right', class: 'dias-column black--text title' },
      ],
      clientesSemFaturamento: [],
      clientesInativo: [],
      vendedores: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      linhaProdutor: [],
      cidades: [],
      clientes: [],
      dynamicPaddingCliente5: '',
      width: '',
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('set-dados-clientes-sem-faturamento', this.handleUpdateDados)

      eventEmit.$on('get-orientacao', this.handleOrientacao)

      eventEmit.$on('set_uploading', this.loadingDados)

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)
    },

    beforeDestroy () {
      eventEmit.$off('set-dados-clientes-sem-faturamento', this.handleUpdateDados)

      eventEmit.$off('get-orientacao', this.handleOrientacao)

      eventEmit.$off('set_uploading', this.loadingDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingCliente5 = 'padding-right: 30rem !important'

          this.width = ''
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingCliente5 = 'padding-right: 11.4rem !important'

          this.width = ''
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingCliente5 = 'padding-right: 4rem !important'

          this.width = '400'
        } else {
          this.dynamicPaddingCliente5 = 'padding-right: 10rem !important'

          this.width = ''
        }
      },

      loadingDados (loading) {
        this.loading = loading
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, area, rede, supervisor, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedores = vendedores
        this.area = area
        this.rede = rede
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao
        this.cidades = cidades
        this.clientes = clientes

        this.showDadosClientesSemFaturamento()
      },

      handleOrientacao (orientacao) {
        this.orientacao = orientacao
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async showDadosClientesSemFaturamento () {
        this.loading = true
        this.clientesSemFaturamento = []
        this.clientesInativo = []

        await Clientes.showClienteSemFaturamentoRede(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhaProducao, this.cidades, this.clientes).then(resposta => {
          if (resposta.data.status) {
            this.clientesSemFaturamento = resposta.data.dadosClientes

            this.clientesInativo = resposta.data.dadosClientesInativos
          } else if (resposta.data.msg === 'Não há dados no período selecionado') {
            this.clientesSemFaturamento = []
            this.clientesInativo = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idClienteSemFaturamento {
      margin: 2rem 0 0 0
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
      word-wrap: break-word;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
    word-wrap: break-word;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #textotabela {
    font-size: 0.75rem !important
  }

  #listItemClientesSemFaturamento {
    margin: -2rem 0 0 -1rem;
  }

  #componenteSemFaturamento {
    margin: -2rem 0 0 0 !important;
  }

  #iconLinkClientesSemFaturamento {
    margin: -2rem 0 0 0
  }

  #iconLinkClientesInativos {
    margin: -2rem 0 0 0
  }
</style>
